import React, { Component } from 'react';
import { Button, Badge } from 'reactstrap';
import { connect } from 'react-redux';
import fileSaver from 'file-saver';
import classnames from 'classnames';
import Table from "../../../components/UI/Table/Table";
import { FINANCIAL, DATA } from '../constants';
import { Preloading } from '../../../components/UI/Preloader/action';
import { downloadTask, uploadTask } from '../action';
import { toast } from 'react-toastify';
import CorporateModal from '../../../components/UI/CorporateModal'
import CommentSection from '../../../components/ReusableComponents/Comments'
import { SUBMITTED } from '../../../Analyst/Cases/constants';
import { HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import { commentReadStatus } from '../../../components/Services/action'
import { commentReadCountRequest, getTableData } from './helper';
class TaskTableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tasks: this.props.tasks,
            taskDataInProcess: null,
            modalType: "",
            modalTitle: '',
            showCorporateModal: false,
            modalCloseHandler: this.toggleCorporateModal,
            readStatus: 0
        };
    }

    componentDidUpdate(prevProps) {
        const {
            tasks,
            readCommentStatus,
            downloadTaskSuccess,
            downloadTaskFailure,
            uploadTaskSuccess,
            uploadTaskFailure,
        } = this.props;
    
        // Update tasks when the tasks prop changes
        if (tasks !== prevProps.tasks) {
            this.setState({ tasks });
            this.props.commentReadStatus(commentReadCountRequest(tasks));
        }
    
        // Update tasks when readCommentStatus prop changes
        if (readCommentStatus !== prevProps.readCommentStatus) {
            const tempTableData = getTableData(readCommentStatus.newCommentCountMap, this.state.tasks);
            this.setState({ tasks: tempTableData });
        }
    
        // Handle successful task download
        if (downloadTaskSuccess !== prevProps.downloadTaskSuccess) {
            this.props.preloading(false);
    
            const { taskSectionMetadata } = this.state.taskDataInProcess;
            if (taskSectionMetadata.surveyExternalId) {
                window.open(downloadTaskSuccess);
            } else if (taskSectionMetadata.surveyExternalId == null && taskSectionMetadata.sectionType === FINANCIAL) {
                const blob = new Blob([downloadTaskSuccess], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                fileSaver.saveAs(blob, `${this.state.taskDataInProcess.taskName}.xlsx`);
            } else if (taskSectionMetadata.surveyExternalId == null && taskSectionMetadata.sectionType === DATA) {
                window.open(downloadTaskSuccess);
            }
        } else if (downloadTaskFailure !== prevProps.downloadTaskFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;Couldn&#39;t download task. {downloadTaskFailure}
                </div>
            );
        }
    
        // Handle successful task upload
        if (uploadTaskSuccess !== prevProps.uploadTaskSuccess) {
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Task uploaded successfully
                </div>
            );
    
            const updatedTaskDataInProcess = {
                ...this.state.taskDataInProcess,
                sectionStatus: SUBMITTED,
            };
    
            const allTasksDone = this.state.tasks.every(task => task.sectionStatus === SUBMITTED);
    
            if (allTasksDone) {
                setTimeout(() => {
                    toast.success(
                        <div>
                            <i className="fa fa-flag-checkered"></i>&nbsp;All tasks submitted successfully. The case is marked as &#34;Completed&#34;.
                        </div>,
                        { autoClose: 7000 }
                    );
                }, 1000);
            }
    
            this.setState({ taskDataInProcess: updatedTaskDataInProcess }, () => {
                this.props.onTaskUploadCompleteHandler();
            });
        } else if (uploadTaskFailure !== prevProps.uploadTaskFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;Error in uploading task! {(uploadTaskFailure.response && uploadTaskFailure.response.data) ? uploadTaskFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
    }

    handleDownload = (taskData) => {
        this.props.preloading(true);
        this.setState({
            taskDataInProcess: taskData
        });
        let downloadDetails = {};

        // @see https://rubixds.atlassian.net/browse/RBX-996
        if (taskData.taskSectionMetadata.surveyExternalId) { // If correspondent has already filled the section earlier, download that one.
            downloadDetails.url = '/survey/url/' + taskData.taskSectionMetadata.surveyExternalId;
            downloadDetails.responseType = '';
        }
        else if (taskData.taskSectionMetadata.surveyExternalId == null && // If this is the first time correspondent is downloading and the type of section is Financial
            taskData.taskSectionMetadata.sectionType === FINANCIAL) {
            downloadDetails.url = '/section/url/financial/' + taskData.taskSectionMetadata.sectionTemplateExternalId;
            downloadDetails.responseType = HTTP_RESPONSE_TYPE_ARRAYBUFFER;
        }
        else if (taskData.taskSectionMetadata.surveyExternalId == null && // If this is the first time correspondent is downloading and the type of section is Data
            taskData.taskSectionMetadata.sectionType === DATA) {
            downloadDetails.url = '/section/url/' + taskData.taskSectionMetadata.sectionTemplateExternalId;
            downloadDetails.responseType = '';
        }

        this.props.downloadTask(downloadDetails);
    }

    handleUpload = (event, taskData) => {
        this.props.preloading(true);
        event.preventDefault();
        this.setState({
            taskDataInProcess: taskData
        });
        const file = event.target.files[0];
        let requestBody;
        requestBody = {
            sectionTemplateId: taskData.taskSectionMetadata.sectionTemplateId,
            reportRequestCaseId: this.props.case.caseId,
            taskId: taskData.taskSectionMetadata.taskId,
            counterPartyId: this.props.case.counterpartyId,
            file: file
        }

        this.props.uploadTask(requestBody);
        event.target.value = null;
    }
    handleCommentCallback = () => {
        this.props.commentReadStatus(commentReadCountRequest(this.props.tasks))
    }
    handleComments = (details) => {
        this.setState(prevState => ({
            body: <div>
                <CommentSection
                    toggle={this.toggleCorporateModal}
                    taskId={details.taskSectionMetadata.taskId}
                    commentSectionCallback={this.handleCommentCallback}
                />
            </div>,
            modalType: "MODAL_TYPE_FORM",
            modalTitle: 'Comments',
            showCorporateModal: !prevState.showCorporateModal,
        }))
    }
    toggleCorporateModal = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            body: null
        }));
    }

    render() {
        return (
            <div>
                <Table
                    data={this.state.tasks}
                    columns={[
                        {
                            Header: "Task Name",
                            id: "taskName",
                            accessor: d => <div title={d.taskName}>{d.taskName}</div>
                            // <div title={d.counterpartyName}>{d.counterpartyName}</div>
                        },
                        {
                            Header: "Status",
                            id: "sectionStatus",
                            accessor: d =>
                                // <Progress value="100" style={{height:"20px" }}
                                //     color={(d.sectionStatus === SUBMITTED || d.sectionStatus === APPROVED) ? "success" :
                                //         (d.sectionStatus === REJECTED || d.sectionStatus === "ERROR") ? "danger" : "info"}
                                //     className={
                                //         classnames(d.sectionStatus === "INPROGRESS" ? 'progress-bar-animated' : '')}>
                                //     {d.sectionStatus !== "INPROGRESS" ? d.sectionStatus : ''}
                                // </Progress>
                                <span> <i className={classnames(d.sectionStatus === SUBMITTED ? 'fa fa-check green_text' : '')}></i>&nbsp;{d.sectionStatus} </span>
                        },
                        {
                            Header: "Comments",
                            id: "comment",
                            accessor: d => <div title={d.taskName}>
                                <Button outline color="info" size="sm" onClick={() => this.handleComments(d)}>
                                    View Comments &nbsp; {d.commentCount}
                                </Button>
                            </div>,
                            className: 'center'
                        },
                        {
                            Header: "Actions",
                            id: "action",
                            accessor: d =>
                                <div>
                                    <div className="btn btn-info upload-action-info position-relative" title="Upload Task Excel" >
                                        <input onChange={(e) => this.handleUpload(e, d)} type="file" name="file" id="file" className="upload-file" title="Upload Excel" />
                                        <i className="fa fa-upload"></i>
                                    </div>
                                    <Button outline color="info" className="ml-3" title="Download Task Excel" onClick={() => this.handleDownload(d)}>
                                        <i className="fa fa-download"></i>
                                    </Button>
                                </div>,
                            className: 'center'
                        }
                    ]}
                    /* defaultSorted={[
                        {
                            id: "taskName",
                            desc: false
                        }
                    ]} */
                    loading={this.props.loading}
                    noDataText="No Tasks found"
                    showPagination={false}
                />
                <CorporateModal toShow={this.state.showCorporateModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle} />
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    downloadTaskSuccess: state.correspondentTasks.downloadTaskSuccess,
    downloadTaskFailure: state.correspondentTasks.downloadTaskFailure,

    uploadTaskSuccess: state.correspondentTasks.uploadTaskSuccess,
    uploadTaskFailure: state.correspondentTasks.uploadTaskFailure,
    readCommentStatus: state.commonReducer.readCommentStatus
})

const mapDispatchToProps = (dispatch) => ({
    downloadTask: (id) => { dispatch(downloadTask(id)) },
    uploadTask: (id) => { dispatch(uploadTask(id)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    commentReadStatus: (data) => { dispatch(commentReadStatus(data)) }
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskTableView);